'use strict';

( function () {
	function ObsPoolController ( $scope, $modal, TOOLTIP_MESSAGES, Session ) {
		var self = this;

		function validateFormula ( formula ) {
			var regex = /(?:avg|sum)\(([^\)]*)\)/g;

			if ( formula.match( regex ) ) {
				formula.match( regex ).forEach( function ( formulae ) {
					if ( formulae.indexOf( $scope.group.id ) !== -1 ) {
						self.isFormulae = true;
					}
				} );
			}
		}

		function activate () {
			if ( $scope.isObsLevel && $scope.readOnly ) {
				self.tooltipPD       = TOOLTIP_MESSAGES.compeletedObsPDMsg;
				self.tooltipEvidence = TOOLTIP_MESSAGES.compeletedObsEvidenceMsg;
			} else if ( $scope.group.hasOwnProperty( 'type' ) && $scope.readOnly ) {
				self.tooltipPD       = TOOLTIP_MESSAGES.compeletedObsGroupPDMsg;
				self.tooltipEvidence = TOOLTIP_MESSAGES.compeletedObsGroupEvidenceMsg;
			} else if ( $scope.group && $scope.readOnly ) {
				self.tooltipPD       = TOOLTIP_MESSAGES.compeletedObsIndicatorPDMsg;
				self.tooltipEvidence = TOOLTIP_MESSAGES.compeletedObsIndicatorEvidenceMsg;
			} else if ( $scope.isObsLevel ) {
				self.tooltipPD       = TOOLTIP_MESSAGES.obsPDMsg;
				self.tooltipEvidence = TOOLTIP_MESSAGES.obsEvidenceMsg;
			} else if ( $scope.group.hasOwnProperty( 'type' ) ) {
				self.tooltipPD       = TOOLTIP_MESSAGES.obsIndicatorPDMsg;
				self.tooltipEvidence = TOOLTIP_MESSAGES.obsIndicatorEvidenceMsg;
			} else {
				self.tooltipPD       = TOOLTIP_MESSAGES.obsGroupPDMsg;
				self.tooltipEvidence = TOOLTIP_MESSAGES.obsGroupEvidenceMsg;
			}

			if ( $scope.activeGroup && $scope.activeGroup.formula ) {
				validateFormula( $scope.activeGroup.formula );
			}

			$scope.group.evidences = ( $scope.group.evidences || [] ).filter( function ( item ) {
				return !( item.scope === 'private' && $scope.readOnly && $scope.observation.observee.id === Session.getCredentials().userId && $scope.observation.observer.id !== Session.getCredentials().userId );
			} );
		}

		function openPPDsModal () {
			$modal.open( {
				'templateUrl'  : '/templates/components/ppd/ppd-modal.html',
				'controller'   : 'PpdModalCtrl',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'windowClass'  : 'pd-modal-size',
				'resolve'      : {
					'ppdSource' : function () {
						return $scope.group;
					},

					'options' : function () {
						return {
							'location'        : 'observation',
							'viewDisabled'    : self.viewOnlyMode,
							'readOnly'        : $scope.readOnly,
							'templatePreview' : $scope.isTemplatePreview
						};
					},

					'resource' : function () {
						return {
							'resourceId' : $scope.observation.id
						};
					}
				}
			} );
		}

		function openEvidencesModal () {
			$modal.open( {
				'templateUrl'  : '/templates/components/evidences/pool/evidences-modal.html',
				'controller'   : 'EvidencesModalCtrl',
				'controllerAs' : 'vm',
				'size'         : 'lg',
				'keyboard'     : false,
				'resolve'      : {
					'group' : function () {
						return $scope.group;
					},

					'update' : function () {
						return $scope.update;
					},

					'observation' : function () {
						return $scope.observation;
					},

					'readOnly' : function () {
						return $scope.readOnly;
					},

					'isObsLevel' : function () {
						return $scope.isObsLevel;
					},

					'isTemplatePreview' : function () {
						return $scope.isTemplatePreview;
					}
				}
			} );
		}

		activate();
		self.openPPDsModal      = openPPDsModal;
		self.openEvidencesModal = openEvidencesModal;
		self.printObs           = $scope.printObs;
		self.readOnlyFlag       = $scope.readOnly;
		self.isScore            = $scope.isScore;
	}

	angular
		.module( 'app.components' )
		.controller( 'ObsPoolController', ObsPoolController );

	ObsPoolController.$inject = [ '$scope', '$modal', 'TOOLTIP_MESSAGES', 'Session' ];
} )();
